import { useState } from "react";

const useContactForm = (initialValues = {}) => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
    ...initialValues,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    if (e?.preventDefault) e.preventDefault();
    setLoading(true);
    setError(null);
    
    const buildFormData = () => {
      const { firstName, lastName, name, ...rest } = form;
      const fullName = (name && name.trim())
        ? name.trim()
        : `${(firstName || '').trim()} ${(lastName || '').trim()}`.trim();
      return { ...rest, name: fullName };
    };

    try {
      const startTime = Date.now();
      const backendBase =
        process.env.REACT_APP_BACKEND_STAGING_URL ||
        process.env.REACT_APP_BACKEND_URL ||
        'http://localhost:3000';

      const payload = buildFormData();

      

      const response = await fetch(`${backendBase}/api/contact`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      
      if (!response.ok) {
        let errMsg = 'Failed to send message';
        let errDetails = undefined;
        try {
          const errJson = await response.json();
          errMsg = errJson?.message || errMsg;
          // Surface validation errors if present
          if (Array.isArray(errJson?.errors) && errJson.errors.length > 0) {
            const validationSummary = errJson.errors
              .map((e) => `${e.param || e.field || 'field'}: ${e.msg || e.message}`)
              .join('; ');
            errMsg = `${errMsg} – ${validationSummary}`;
            errDetails = errJson.errors;
          }
        } catch (_) {
          try {
            const errText = await response.text();
            errMsg = errText || errMsg;
          } catch (_) {
            // ignore
          }
        }
       
        // Return structured error so UI can show specifics
        return { success: false, error: errMsg, details: errDetails, status: response.status };
      }
      const data = await response.json();
     
      return { success: true, data };
    } catch (err) {
      console.error('[ContactForm] Unexpected error', err);
      setError(err.message);
      return { success: false, error: err.message };
    } finally {
      setLoading(false);
    }
  };

  return { form, loading, error, handleChange, handleSubmit };
};

export default useContactForm;
